export const NAVIGATION_BAR_CLICKED = 'Navigation Bar Clicked';

export interface NavigationBarClickContext {
  /** Top-level nav tab / drawer root (e.g. main menu label). */
  menuName: string;
  /** Next parent label when present. */
  categoryName?: string;
  /** Next parent label when present. */
  subcategoryName?: string;
  /** Clicked link/row label. */
  buttonName: string;
}

function clean(s: string | undefined): string {
  return (s ?? '').trim();
}

export function navigationBarClickedEventProperties(ctx: NavigationBarClickContext): Record<string, string> {
  return {
    'Menu Name': clean(ctx.menuName),
    'Category Name': clean(ctx.categoryName),
    'Subcategory Name': clean(ctx.subcategoryName),
    'Button Name': clean(ctx.buttonName),
  };
}
